import type { ConstellationDot } from '../types';
import { getGlowSparkStrength } from './poseHelpers';
import { getRingCoordinates, getRingPoint } from './ring';

type ListeningDotInput = Readonly<{
	audioGain: number;
	color: string;
	index: number;
	timeSeconds: number;
}>;

const LISTENING_ROTATION_RADIANS_PER_SECOND = (10 * Math.PI) / 180;
const LISTENING_RADIAL_BOB_AMPLITUDE = 1.35;
const LISTENING_PULSE_RADIANS_PER_SECOND = 3.8;
const DOT_PHASE_OFFSET_RADIANS = 0.9;

// Controls how tightly the glow follows each dot's movement.
const GLOW_CONCENTRATION_POWER = 2;
const MAXIMUM_GLOW_STRENGTH = 0.9;

export const createListeningDot = ({
	audioGain,
	color,
	index,
	timeSeconds,
}: ListeningDotInput): ConstellationDot => {
	const { count, radius, ringIndex } = getRingCoordinates(index);

	const pulse = Math.sin(
		timeSeconds * LISTENING_PULSE_RADIANS_PER_SECOND + index * DOT_PHASE_OFFSET_RADIANS,
	);

	// Neighboring movement overlap slightly
	const glowStrength = getGlowSparkStrength(pulse, GLOW_CONCENTRATION_POWER, MAXIMUM_GLOW_STRENGTH);

	return {
		...getRingPoint(
			ringIndex,
			count,
			radius + pulse * LISTENING_RADIAL_BOB_AMPLITUDE * audioGain,
			timeSeconds * LISTENING_ROTATION_RADIANS_PER_SECOND,
		),
		brightness: 0.68 + (pulse + 1) * 0.12 * audioGain,
		color,
		glowStrength,
		scale: 0.92 + (pulse + 1) * 0.065 * audioGain,
	};
};
